[
  {
    "name": "Slovenčina",
    "code": "SK",
    "iso": "sk-SK"
  },
  {
    "name": "English",
    "code": "EN",
    "iso": "en-US"
  }
]
